import {

    ASYNC_OPEN_INTERNATIONAL_FETCH,
    ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS,
    ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED
} from '../constants';

import { updateObject } from '../../../shared/utilities/reducer';
import common from '../../../shared/utilities/common';

const initialState = {
    isFetching: true,
    statusCode: "",
    statusMessage: "",
    errorMessage: '',
    errorDesc: '',
    actionName: '',
    actionValue: '',
    errorObj: {},
    pageData: "",
    selectedPlan: {},
    offerValue: {},
    
}

export const openInternationalRepTools_ILD = (state, action) => {
    return updateObject(state, {
        isFetching: true
    });
};

export const openInternationalRepToolsModalSuccess_ILD = (state, action) => {

    let responseCode = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseCode;
    let responseMessage = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseMessage;
    let responseBody = action.msResp && action.msResp.body;

    return updateObject(state, {
        isFetching: false,
        statusCode: responseCode,
        statusMessage: responseMessage,
        errorMessage: common.isError(responseCode, responseMessage, responseBody),
        errorDesc: common.isErrorDesc(responseCode, responseMessage, responseBody),
        actionName: common.isActionName(responseCode, responseMessage, responseBody),
        actionValue: common.isActionValue(responseCode, responseMessage, responseBody),
        errorObj: responseCode !== "00" && action.msResp && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
        pageData: responseBody.data
    });
};

export const openInternationalRepToolsModalFailure_ILD = (state, action) => {

   
    let msResp = action && action.err && action.err.response && action.err.response.data;
    let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
    let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
    let body = msResp && msResp.body;
    return updateObject(state, {
        isFetching: false,
        pageData: {},
        statusCode: responseCode ? responseCode : '',
        errorMessage: common.isError(responseCode, responseMessage, body),
        errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
        actionName: common.isActionName(responseCode, responseMessage, body),
        actionValue: common.isActionValue(responseCode, responseMessage, body),
        errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
    });
};


export const InternationalRepToolsReducer_ILD = (state = initialState, action) => {

    const { type } = action;
    switch (type) {

        case ASYNC_OPEN_INTERNATIONAL_FETCH:
            return openInternationalRepTools_ILD(state, action);
        case ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS:
            return openInternationalRepToolsModalSuccess_ILD(state, action);
        case ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED:
            return openInternationalRepToolsModalFailure_ILD(state, action);
        default:
            return state;
    }
};

